import React, {Component} from 'react'

export default class Index extends Component {
  render() {
    return <div className="vzuu-content">{this.props.children}</div>
  }
}
